import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { i18n } from "@/plugins/i18n";
import "./plugins/Auth";
import Vuelidate from "vuelidate";
import Vuetify from "vuetify";
Vue.use(Vuelidate);

Vue.prototype.$apiRoot = process.env.VUE_APP_API_URL;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
